import React, { useState } from 'react';
import { useListPublishedBlogPostsQuery } from '@/api/client';
import Header from '@feature/app-download/components/Header';
import MobileMenu from '@feature/app-download/components/MobileMenu';
import { useResponsive } from '@feature/app-download/hooks/useResponsive';
import BlogCard from './components/BlogCard';
import './Blog.css';

function BlogListPage() {
  const isMobile = useResponsive();
  const [menuOpen, setMenuOpen] = useState(false);
  const { data, isLoading } = useListPublishedBlogPostsQuery({ page: 1, size: 50 });
  const posts = data?.items ?? [];

  return (
    <div className="blog-page">
      <Header isMobile={isMobile} onMenuToggle={() => setMenuOpen(!menuOpen)} />
      <MobileMenu menuOpen={menuOpen} onClose={() => setMenuOpen(false)} />
      <header className="blog-page-header">
        <h1 className="blog-page-title">Blog</h1>
        <p className="blog-page-subtitle">Stories, updates, and insights from Hereabout</p>
      </header>
      <main className="blog-page-content">
        {isLoading ? (
          <div className="blog-page-loading">Loading...</div>
        ) : posts.length === 0 ? (
          <div className="blog-page-empty">No posts yet. Check back soon.</div>
        ) : (
          <div className="blog-list">
            {posts.map(post => (
              <BlogCard key={post.id} post={post} />
            ))}
          </div>
        )}
      </main>
    </div>
  );
}

export default BlogListPage;
